import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MultiAssessmentState } from './multi-assessment.state';

export const selectMultiAssessmentState =
  createFeatureSelector<MultiAssessmentState>('multiAssessment');

export const selectSelectedMultiAssessment = createSelector(
  selectMultiAssessmentState,
  state => state.selectedAssessment
);

export const selectMultiAssessmentStudent = createSelector(
  selectMultiAssessmentState,
  state => state.student
);
